import axios from 'axios';
import { mavim } from '../../app/conf';

const headers = token => ({
    'Content-Type': 'application/json',
    'x-access-token': token
});

export const getCatalogs = token =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/dashboard/catalogs`,
        headers: headers(token)
    });
